import {
    GENERAL_INFORMATION_READY,
    EXPRESS_CONFIGURATION_READY,
    CREATE_USER_REQUEST,
    CREATE_USER_SUCCESS,
    CREATE_USER_FAILURE,
    GET_USERS_REQUEST,
    GET_USERS_SUCCESS,
    GET_USERS_FAILURE,
    GET_USER_REQUEST,
    GET_USER_SUCCESS,
    GET_USER_FAILURE,
    CLEAN_USERS,
    CLEAN_USER,
    SET_TOTAL_USERS,
    DELETE_USER_REQUEST,
    DELETE_USER_SUCCESS,
    DELETE_USER_FAILURE,
    GET_TELEPHONY_PROFILES_REQUEST,
    GET_TELEPHONY_PROFILES_SUCCESS,
    GET_TELEPHONY_PROFILES_FAILURE,
    UPDATE_USER_REQUEST,
    UPDATE_USER_SUCCESS,
    UPDATE_USER_FAILURE
} from '../actions/userActionTypes';
import { reject, map } from 'lodash';

const initialState = {
    generalInformationReady: false,
    generalInformation: {
        Names: '',
        LastNames: '',
        Emails: '',
        Language: 'es',
        Status: 1,
        MobilePhone: ''
    },
    expressConfigurationReady: false,
    expressConfiguration: {
        UserType: 'PHONE',
        Extension: '',
        ExtensionPassword: '',
        ShowPassword: false,
        RepeatedPassword: '',
        ShowRepeatedPassword: false,
        Profile: 'local',
        Local: [true, false, false],
        National: [true, false, false],
        International: [true, false, false],
        InterPBX: [true, false, false],
        Mobile: [true, false, false],
        Special: [true, false, false],
        Emergency: [true, false, false],
        EnableSecurityPIN: false,
        ShowSecurityPIN: false,
        UseSecurityPin: false,
        SecurityPin: '',
        ExtensionOnWebEnabled: false,
        ExtensionOnMobileEnabled: false,
        UseVoicemail: false,
        Monitor: false,
        Protocol: 'SIP',
        RecordignCapacity: 10
    },
    isCreating: false,
    creationError: false,
    users: [],
    isFetching: false,
    error: false,
    totalUsers: 0,
    TelephonyProfiles: {
        fetching: false,
        error: false,
        profiles: []
    },
    edition: {
        user: null,
        isEditing: false,
        error: false,
        fetching: false
    },
    searchText: ''
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GENERAL_INFORMATION_READY: {
            return {
                ...state,
                generalInformationReady: action.payload.status,
                generalInformation: action.payload.data
            };
        }
        case EXPRESS_CONFIGURATION_READY: {
            return {
                ...state,
                expressConfigurationReady: action.payload.status,
                expressConfiguration: action.payload.data
            };
        }
        case CREATE_USER_REQUEST: {
            return {
                ...state,
                isCreating: true
            };
        }
        case CREATE_USER_SUCCESS: {
            return {
                ...state,
                isCreating: false,
                error: false
            };
        }
        case CREATE_USER_FAILURE: {
            return {
                ...state,
                isCreating: false,
                error: true
            };
        }
        case GET_USERS_REQUEST: {
            return {
                ...state,
                isFetching: true,
                searchText: action.payload.searchText
            };
        }
        case GET_USERS_SUCCESS: {
            return {
                ...state,
                isFetching: false,
                users: [...state.users, ...action.payload.users],
                error: false
            };
        }
        case GET_USERS_FAILURE: {
            return {
                ...state,
                isFetching: false,
                error: true,
                searchText: ''
            }
        }
        case CLEAN_USERS: {
            return {
                ...state,
                users: [],
                totalUsers: 0
            };
        }
        case CLEAN_USER: {
            return {
                ...state,
                edition: {
                    user: null,
                    isEditing: false,
                    error: false,
                    fetching: false
                },
                generalInformationReady: false,
                expressConfigurationReady: false
            };
        }
        case SET_TOTAL_USERS: {
            return {
                ...state,
                totalUsers: action.payload.total
            };
        }
        case DELETE_USER_REQUEST: {
            const userlist = map([...state.users], user => user.UserId === action.payload.id
                ? { ...user, removing: true }
                : user
            );

            return {
                ...state,
                users: userlist
            };
        }
        case DELETE_USER_SUCCESS: {
            const displayedUsers = reject([...state.users], ['UserId', action.payload.id]);
            const newTotal = state.totalUsers - 1;

            return {
                ...state,
                users: displayedUsers,
                totalUsers: newTotal
            };
        }
        case DELETE_USER_FAILURE: {
            const userlist = map([...state.users], user => user.UserId === action.payload.id
                ? { ...user, removing: false }
                : user
            );

            return {
                ...state,
                users: userlist
            };
        }
        case GET_TELEPHONY_PROFILES_REQUEST: {
            return {
                ...state,
                TelephonyProfiles: {
                    ...state.TelephonyProfiles,
                    fetching: true
                }
            }
        }
        case GET_TELEPHONY_PROFILES_SUCCESS: {
            return {
                ...state,
                TelephonyProfiles: {
                    ...state.TelephonyProfiles,
                    fetching: false,
                    profiles: action.payload.TelephonyProfiles,
                    error: false
                },
                edition: {
                    ...state.edition,
                    error: false
                }
            }
        }
        case GET_TELEPHONY_PROFILES_FAILURE: {
            return {
                ...state,
                TelephonyProfiles: {
                    ...state.TelephonyProfiles,
                    fetching: false,
                    profiles: [],
                    error: true
                },
                edition: {
                    ...state.edition,
                    error: true
                }
            }
        }
        case GET_USER_REQUEST: {
            return {
                ...state,
                edition: {
                    ...state.edition,
                    fetching: true
                }
            };
        }
        case GET_USER_SUCCESS: {
            return {
                ...state,
                edition: {
                    ...state.edition,
                    fetching: false,
                    user: action.payload.user,
                    error: false
                },
            };
        }
        case GET_USER_FAILURE: {
            return {
                ...state,
                edition: {
                    ...state.edition,
                    fetching: false,
                    error: true
                }
            }
        }
        case UPDATE_USER_REQUEST: {
            return {
                ...state,
                edition: {
                    ...state.edition,
                    isEditing: true
                }
            };
        }
        case UPDATE_USER_SUCCESS: {
            return {
                ...state,
                edition: {
                    ...state.edition,
                    isEditing: false,
                    error: false
                }
            };
        }
        case UPDATE_USER_FAILURE: {
            return {
                ...state,
                edition: {
                    ...state.edition,
                    isEditing: false,
                    error: true
                }
            };
        }
        default: return state;
    }
};
